import { NdbxIconModule } from '@allianz/ngx-ndbx/icon';
import { Component, input } from '@angular/core';
import { NxButtonModule } from '@aposin/ng-aquila/button';
import { NxCardModule } from '@aposin/ng-aquila/card';
import { NxCopytextModule } from '@aposin/ng-aquila/copytext';
import { NxGridModule } from '@aposin/ng-aquila/grid';
import { NxHeadlineModule } from '@aposin/ng-aquila/headline';
import { NxIconModule } from '@aposin/ng-aquila/icon';
import { NxSpinnerModule } from '@aposin/ng-aquila/spinner';
import { TranslateModule } from '@ngx-translate/core';

import { Company } from '#services/company/company.service';
import { injectCountriesQuery } from '#services/dataRef/dataRefQuery.service';

export interface CompanySearchResult {
  name: string;
  ehid: string;
  countryCode: string;
  town?: string;
  streetName: string;
  streetNumber: string;
  postCode: string;
  nationalIdentifier?: {
    idTypeCode: string;
    idValue: string;
    priorityNumber: number;
  };
}

export type SearchResultWithIteration = CompanySearchResult & {
  iterationId?: string;
  isIterationOpen: boolean;
  isLoading: boolean;
  previousIterationId?: string;
};

export const formatCompany = (company: Company): CompanySearchResult => ({
  ehid: company.companyId,
  name: company.legalData.companyName,
  countryCode: company.address.countryCode,
  streetName: company.address.streetName,
  streetNumber: company.address.streetNumber,
  town: company.address?.town,
  postCode: company.address?.postCodes?.[0]?.postCodeValue,
  nationalIdentifier: company.companyIdentifiers?.toSorted((a, b) => a.priorityNumber - b.priorityNumber)[0],
});

export interface CompanySearchButtonData {
  class?: string;
  nxButton: string;
  disabled?: boolean;
  onSelect: (resultIndex: number) => Promise<void>;
  i18n: string;
  errorI18n?: string;
}

@Component({
  selector: 'kyc-company-search-results',
  imports: [
    NxCardModule,
    NxGridModule,
    NxHeadlineModule,
    NxButtonModule,
    NxIconModule,
    NdbxIconModule,
    NxSpinnerModule,
    TranslateModule,
    NxCopytextModule,
  ],
  templateUrl: './company-search-results.component.html',
  styleUrl: './company-search-results.component.scss',
})
export class CompanySearchResultsComponent {
  readonly results = input.required<CompanySearchResult[]>();
  readonly buttonsData = input.required<CompanySearchButtonData[][]>();
  readonly isLoading = input.required<boolean>();
  readonly isIterationLoading = input<(index: number) => boolean>();

  private readonly countries = injectCountriesQuery();

  getCountryLabel(countryCode: string) {
    return this.countries.data()?.find((c) => c.countryCode === countryCode)?.countryCommonLabel;
  }
}
